// src/lib/utils.js

export const EMOJIS = [
  '🥫','🍝','🥚','🧀','🥛','🍞','🥩','🐟','🍎','🍌',
  '🥦','🧅','🧄','🫘','🌽','🍅','🥓','🍗','🧆','🫙',
  '🧂','🫒','🥜','🍫','🍪','🥐','🍷','🍺','🧃','🫖',
  '🥕','🧁','🫐','🍋','🥝','🫚','🧈','🥞','🍖','🐓',
  '🧴','🥤',
];

export const UNITS = [
  'unité(s)', 'boîte(s)', 'paquet(s)', 'bouteille(s)',
  'kg', 'g', 'L', 'cl', 'sachet(s)',
];

export const CATS = {
  sec:         { label: 'Sec / Épicerie', icon: '🧂' },
  frigo:       { label: 'Réfrigérateur',  icon: '❄️' },
  congelateur: { label: 'Congélateur',    icon: '🧊' },
  boissons:    { label: 'Cave / Boissons',icon: '🥤' },
  autre:       { label: 'Autre',          icon: '📦' },
  entretien:   { label: 'entretien',      icon: '🧴' },
};

// ─── Date helpers ─────────────────────────────────────────────────
export function daysLeft(dateStr) {
  if (!dateStr) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const exp   = new Date(dateStr); exp.setHours(0, 0, 0, 0);
  return Math.round((exp - today) / 86_400_000);
}

export function getStatus(dateStr, alertDays = 7) {
  const n = daysLeft(dateStr);
  if (n === null) return 'ok';
  if (n < 0) return 'expired';
  if (n <= parseInt(alertDays, 10)) return 'soon';
  return 'ok';
}

export function expiryLabel(dateStr) {
  const n = daysLeft(dateStr);
  if (n === null) return '';
  if (n < 0)   return `Périmé (${Math.abs(n)}j)`;
  if (n === 0) return "Expire aujourd'hui !";
  if (n === 1) return 'Expire demain';
  if (n <= 7)  return `Expire dans ${n}j`;
  return `DLC : ${new Date(dateStr).toLocaleDateString('fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric',
  })}`;
}

// ─── Category helpers ─────────────────────────────────────────────
export function guessEmojiFromCat(cat) {
  return { frigo:'🧀', congelateur:'🧊', boissons:'🥤', sec:'🥫', autre:'📦', entretien:'🧴' }[cat] ?? '🥫';
}

export function parseCatFromOpenFoodFacts(tags = []) {
  const s = tags.join(' ');
  if (s.includes('surgel') || s.includes('frozen'))                              return 'congelateur';
  if (s.includes('boisson') || s.includes('beverage') || s.includes('drink') ||
      s.includes('wine')    || s.includes('beer'))                               return 'boissons';
  if (s.includes('frais')   || s.includes('fresh') || s.includes('dairy') ||
      s.includes('viande')  || s.includes('meat'))                               return 'frigo';
  return 'sec';
}

// ─── OpenFoodFacts lookup ─────────────────────────────────────────
import { getProduct, saveProduct, updateLastUsed } from "./products";

export async function lookupBarcode(code) {

  // 🔥 1. CHECK FIRESTORE EN PREMIER
  const local = await getProduct(code);

  if (local) {
    // 📌 mise à jour usage
    await updateLastUsed(code);

    return {
      name: local.name,
      emoji: local.emoji,
      cat: local.cat,
      unit: local.unit,
      qty: local.qty,
    };
  }

  // 🌍 2. API FOOD
  try {
    let res = await fetch(`https://world.openfoodfacts.org/api/v0/product/${code}.json`);
    let data = await res.json();

    if (data.status === 1) {
      const product = {
        name: data.product.product_name || "Produit alimentaire",
        emoji: "🍽️",
        cat: "sec",
        unit: data.product.unit || 'unité(s)',
        qty: data.product.qty || 1,
      };

      await saveProduct(code, product);
      return product;
    }

    // 🧼 3. fallback produits entretien
    const fallback = {
      name: `Produit ${code}`,
      emoji: "📦",
      cat: "autre",
      unit: "",
      qty: 1,
    };

    await saveProduct(code, fallback);
    return fallback;

  } catch (e) {
    return {
      name: `Produit ${code}`,
      emoji: "📦",
      cat: "autre",
      unit: "",
      qty: 1,
    };
  }
}

// ─── Claude AI recipes ────────────────────────────────────────────
export async function fetchRecipes({ inventory, alertDays, preferences }) {
  const thr       = parseInt(alertDays || 7, 10);
  const itemsSoon = inventory.filter(i => { const d = daysLeft(i.expiry); return d !== null && d <= thr; });
  const itemsOk   = inventory.filter(i => { const d = daysLeft(i.expiry); return d === null || d > thr; });
  const fmt       = i => `${i.name} (${i.qty} ${i.unit || 'unité(s)'})`;

  let stockDesc = '';
  if (itemsSoon.length) stockDesc += `⚠️ À consommer en priorité : ${itemsSoon.map(fmt).join(', ')}\n`;
  if (itemsOk.length)   stockDesc += `Disponible : ${itemsOk.map(fmt).join(', ')}`;

  const prompt = `Tu es un chef cuisinier français. Contenu de la réserve :\n\n${stockDesc}\n\nPréférences : ${preferences || 'aucune'}\n\nPropose exactement 3 recettes réalisables avec ces ingrédients. Priorise les produits urgents.\n\nRéponds UNIQUEMENT en JSON valide, sans markdown, sans backticks :\n[{"titre":"...","temps":"X min","difficulte":"Facile","ingredients_utilises":["..."],"etapes":["...","...","..."]}]`;

  const res = await fetch('https://api.anthropic.com/v1/messages', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({
      model:      'claude-sonnet-4-20250514',
      max_tokens: 1400,
      messages:   [{ role: 'user', content: prompt }],
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error?.message || `HTTP ${res.status}`);
  }

  const data = await res.json();
  let raw = (data.content || []).map(c => c.text || '').join('').trim();
  raw = raw.replace(/```json|```/g, '').trim();
  const start = raw.indexOf('['), end = raw.lastIndexOf(']');
  if (start === -1 || end === -1) throw new Error('Format inattendu');
  return JSON.parse(raw.slice(start, end + 1));
}

// ─── Demo data factory ────────────────────────────────────────────
export function buildDemoItems() {
  const add = n => {
    const d = new Date(); d.setDate(d.getDate() + n);
    return d.toISOString().split('T')[0];
  };
  return [
    { name:'Pâtes spaghetti n°5', emoji:'🍝', cat:'sec',          qty:3, stockMin:0, unit:'paquet(s)',    expiry:add(340), note:'Barilla',   barcode:'' },
    { name:'Lait demi-écrémé',    emoji:'🥛', cat:'frigo',        qty:2, stockMin:0, unit:'bouteille(s)', expiry:add(5),   note:'',          barcode:'' },
    { name:'Steaks hachés',       emoji:'🥩', cat:'congelateur',  qty:8, stockMin:0, unit:'unité(s)',     expiry:add(60),  note:'15% MG',    barcode:'' },
    { name:'Sauce tomate',        emoji:'🥫', cat:'sec',          qty:4, stockMin:0, unit:'boîte(s)',     expiry:add(180), note:'',          barcode:'' },
    { name:'Camembert',           emoji:'🧀', cat:'frigo',        qty:1, stockMin:0, unit:'unité(s)',     expiry:add(2),   note:'Président', barcode:'' },
    { name:'Yaourts nature',      emoji:'🧁', cat:'frigo',        qty:6, stockMin:0, unit:'unité(s)',     expiry:add(-3),  note:'',          barcode:'' },
    { name:'Vin rouge',           emoji:'🥤', cat:'boissons',     qty:6, stockMin:0, unit:'bouteille(s)', expiry:'',       note:'Bordeaux',  barcode:'' },
    { name:'Farine T55',          emoji:'🫙', cat:'sec',          qty:1, stockMin:0, unit:'paquet(s)',    expiry:add(120), note:'1kg',       barcode:'' },
    { name:'Oeufs fermiers',      emoji:'🥚', cat:'frigo',        qty:6, stockMin:0, unit:'unité(s)',     expiry:add(10),  note:'',          barcode:'' },
    { name:'Carottes',            emoji:'🥕', cat:'frigo',        qty:5, stockMin:0, unit:'unité(s)',     expiry:add(6),   note:'',          barcode:'' },
  ];
}
